import {createFileRoute} from '@tanstack/react-router'
import {Container, Stack, Stepper, Tabs, Title} from "@mantine/core";
import NewDailyMenuTimes from "@components/newDailyMenu/times.tsx";
import {CreateDailyMenuDto, DailyMenuDto} from "@techheavencz/zmrzlina-admin-api";
import {useState} from "react";
import NewDailyMenuItems from "@components/newDailyMenu/items.tsx";
import {useCreateDailyMenu} from "@state/server/dailyMenu.mutation.ts";
import DailyMenu from "@components/dailyMenu.tsx";
import {format} from "date-fns";
import {cs} from "date-fns/locale";
import NewDailyMenuPreview from "@components/newDailyMenu/preview.tsx";

export const Route = createFileRoute('/_authenticated/_dailymenu/dailymenu/new')({
	component: RouteComponent,
})

function RouteComponent() {
	const [formState, setFormState] = useState<Partial<CreateDailyMenuDto> | null>(null);
	const [activeStep, setActiveStep] = useState(0);
	const {mutateAsync: createDailyMenu} = useCreateDailyMenu()
	const [createdDailyMenu, setDailyMenu] = useState<DailyMenuDto | null>(null)


	const onTimesSubmit = (data: Pick<CreateDailyMenuDto, "day" | "opening" | "closing" | "orderBy" | "note">) => {
		setFormState(currentState => ({
			...currentState,
			...data
		}))
		setActiveStep(1)
	}

	const onItemsGoback = () => {
		setActiveStep(0)
	}

	const onItemsSubmit = (items: number[]) => {
		setFormState(currentState => ({
			...currentState,
			items: items.map(itemId => ({itemId}))
		}))
		setActiveStep(2)
	}

	const onConfirmGoBack = () => {
		setActiveStep(1)
	}

	const onReviewProceed = () => {
		if (formState && formState.opening && formState.closing && formState.day && formState.orderBy && formState.items && formState.items?.length > 0) {
			createDailyMenu(formState as CreateDailyMenuDto).then((value) => {
				setDailyMenu(value)
				setActiveStep(3)
			})
		}
	}

	return (
		<Tabs.Panel value={"new"}>
			<Container fluid>
				<Title order={2} py={"md"}>Nová denní nabídka</Title>

				<Stepper active={activeStep}>
					<Stepper.Step label={"Otevírací doba"} key={"times"}>
						<Title order={3}>Otevírací doba</Title>
						<NewDailyMenuTimes submitCallback={onTimesSubmit} initialState={formState ?? undefined}/>
					</Stepper.Step>
					<Stepper.Step label={"Položky v nabídce"} key={"items"}>
						<Title order={3}>Položky v nabídce</Title>
						<NewDailyMenuItems goback={onItemsGoback} nextStep={onItemsSubmit}
										   initialState={formState?.items ?? []}/>
					</Stepper.Step>
					<Stepper.Step label={"Kontrola a náhled"} key={"review"}>
						<Stack>
							<Title order={3}>Kontrola a náhled</Title>
							<NewDailyMenuPreview data={formState as unknown as CreateDailyMenuDto}
												 confirm={onReviewProceed} goBack={onConfirmGoBack}/>
						</Stack>
					</Stepper.Step>
					<Stepper.Completed>
						{createdDailyMenu && <Container fluid>
                            <Title order={3}>Denní nabídka
                                ({format(new Date(formState?.day ?? ""), "EEEE, do MMMM yyyy", {locale: cs})})</Title>
							{createdDailyMenu && <DailyMenu dailyMenu={createdDailyMenu}/>}
                        </Container>}
					</Stepper.Completed>
				</Stepper>
			</Container>
		</Tabs.Panel>
	)
}
